/**
 * Card Image Hover - Mobile Slider
 * Initializes Swiper slider for hover image cards.
 */

import { Swiper } from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-card-image-hover .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		const slides = slider.querySelectorAll('.swiper-slide');

		if (slides.length < 2) {
			return;
		}

		// Add unique class for targeting pagination.
		slider.parentElement.classList.add(
			`block-card-image-hover__container--${index}`
		);

		const settings = {
			slidesPerView: 1.15,
			spaceBetween: 16,
			grabCursor: true,
			modules: [A11y, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: `.block-card-image-hover__container--${index} .swiper-pagination`,
				clickable: true,
			},
			breakpoints: {
				768: {
					enabled: false,
					slidesPerView: 'auto',
				},
			},
		};

		new Swiper(slider, settings);
	});
}
